import "react"
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog.tsx"
import { Button } from "@/components/ui/button.tsx"
import { cn } from "@/lib/utils.ts"

export function InfoDialog({
  isOpen,
  setIsOpen,
  title,
  children,
  footer,
  className,
  contentClassName,
  showCloseButton = true,
  variant = "dark"
}) {
  const { t } = useTranslation()

  const variants = {
    dark: "bg-black/90 text-white border-white/20",
    light: "bg-gray-100 text-black border-none"
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className={cn(
          "sm:max-w-2xl p-0 overflow-hidden flex flex-col",
          "max-h-[calc(100dvh-env(safe-area-inset-top)-env(safe-area-inset-bottom)-4rem)]",
          variants[variant],
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={cn("relative p-6 overflow-y-auto flex-grow", contentClassName)}>
          <DialogHeader>
            <DialogTitle className="text-xl font-bold mb-4">
              {title}
            </DialogTitle>
            <DialogDescription className="sr-only">
              {title}
            </DialogDescription>
          </DialogHeader>
          {children}
        </div>
        <div className="p-6 pt-0 flex-shrink-0">
          <DialogFooter className="mt-0 bg-transparent border-none p-0 -mx-0 -mb-0 rounded-none">
            {footer || (
              showCloseButton && (
                <Button
                  variant={variant === "dark" ? "outline" : "default"}
                  className={cn(
                    variant === "dark" && "text-white border-white hover:bg-white hover:text-black",
                    variant === "light" && "bg-black text-white hover:bg-gray-800"
                  )}
                  onClick={() => setIsOpen(false)}
                >
                  {t('buttons.close') || "Close"}
                </Button>
              )
            )}
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
